const setStartSettings = ({ commit }, settings) => {
  commit("SET_START_SETTINGS", settings);
};

export default setStartSettings;
